import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "mainCard", "bodyTable", "footerTable", "checkboxShow", "clearListBtn", "optionBtn", "main"]

  connect() {
    this.controllerName = `app--communications--interactions--entities--list`
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.itemsOnPage = 300
    this.pageNumber = 0
    this.numberPages = []
    this.tableCols = 9
    this.sort = { mode: `desc`, field: `started_at_to_time` }
    this.hasShow = false
  }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  doListHtml() {
    if (this.application.permissions[this.permission].can_create) {
      var addLine = `<span data-action="click->${this.controllerName}#addCall" class="dropdown-item py-1 pointer dropdown-submenu-item">Adicionar Interação</span>`
    } else {
      var addLine = ``
    }
    var addLine = ``

    var refreshLine = `<span data-action="click->${this.controllerName}#refreshCalls" class="dropdown-item py-1 pointer dropdown-submenu-item">Atualizar Interações</span>`

    var clearBtnHtml = `<span class="mc-tooltip">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0 d-none" data-${this.controllerName}-target="clearListBtn" data-action="click->${this.controllerName}#clearList" type="button">
                            <span class="material-icons md-dark">clear</span>
                          </button>
                          <span class="mc-tooltiptext">Limpar</span>
                        </span>`

    var submenuHtml = `<div class="dropdown mc-tooltip" data-${this.controllerName}-target="optionBtn">
                        <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-toggle="dropdown" id="submenuMenuDrop" type="button"><span class="material-icons md-dark">more_vert</span></button>
                        <div aria-labelledby="submenuMenuDrop" class="dropdown-menu dropdown-menu-right menu" style="font-size:80%">
                          ${addLine}
                          ${refreshLine}
                        </div>
                        <span class="mc-tooltiptext">Opções</span>
                      </div>`

    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-title-table-list">Todos Interações</h6>
                    <input class="form-control f-070 w-50 mx-auto" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable" placeholder="Buscar ..." type="text">
                    <div class="card-actions ml-auto py-0">
                      ${clearBtnHtml}
                      ${submenuHtml}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <table class="table table-sm table-hover" data-app--helpers--search-target="searchTable" style="font-size:80%;">
                          <thead>
                            <tr>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Data</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Início</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Fim</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-12 align-middle">Interação</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-12 align-middle">Destinatário</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle">Telefone</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Duração</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Custo</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle">Encerramento</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle"></th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle"></th>
                            </tr>
                          </thead>
                          <tbody data-${this.controllerName}-target="bodyTable">
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.6) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 10))
      controller.doDataTable()
    })
  }

  doDataTable() {
    this.current_calls = this.application.calls

    if (this.sort.mode == `asc`) {
      var calls = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(this.current_calls, this.sort.field)
    } else if (this.sort.mode == `desc`) {
      var calls = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(this.current_calls, this.sort.field)
    }

    if (calls.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(calls.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (calls[x] !== undefined) {
            internPage[internPage.length] = calls[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: calls.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="${this.tableCols}" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Interações</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.callTablePartial(element, data.length))
      });
    }
  }

  callTablePartial(element, length) {

    if (element.status == `active`) {
      var status = `<span class="mc-tooltip"><span class="material-icons md-sm md-success default">done</span><span class="mc-tooltiptext">${element.status_pretty}</span></span>`
    } else if (element.status == `inactive`) {
      var status = `<span class="mc-tooltip"><span class="material-icons md-sm md-danger default">clear</span><span class="mc-tooltiptext">${element.status_pretty}</span></span>`
    }

    var distance = element.duration
    var minutes = Math.floor((distance % (60 * 60)) / 60);
    var seconds = Math.floor(distance % (60));

    if (minutes < 0) {
      minutes = `00`
    } else if (minutes < 10) {
      minutes = `0${minutes}`
    }

    if (seconds < 0) {
      seconds = `00`
    } else if (seconds < 10) {
      seconds = `0${seconds}`
    }

    var duration = `${minutes}:${seconds}`

    if (this.application.permissions[this.permission].can_update) {
      var refreshBtn = `<button data-action="click->${this.controllerName}#refreshSingleCall" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                          <span class="material-icons md-sm md-dark">refresh</span>
                          <span class="mc-tooltiptext">Atualizar Interação</span>
                        </button>`
    } else {
      var refreshBtn = ``
    }

    if (element.record_url) {
      var playBtn = `<button data-action="click->${this.controllerName}#listenToAudio" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                        <span class="material-icons md-sm md-dark">play_circle_filled</span>
                        <span class="mc-tooltiptext">Escutar Interação</span>
                      </button>`
      // var playBtn = `<button data-kind="audio" data-obj-id="${element.id}" data-obj-type="communication_voip_calls" data-action="click->${this.controllerName}#goToFile" type="button" data-url="${element.record_url}" class="btn btn-sm btn-table p-0 mc-tooltip">
      //                   <span class="material-icons md-sm md-dark">play_circle_filled</span>
      //                   <span class="mc-tooltiptext">Escutar Interação</span>
      //                 </button>`
    } else {
      var playBtn = ``
    }

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}">`
    }

    // `<td style="font-size:80%;" scope="col" class="p-1 align-middle">
    //   <span class="p-0 mc-tooltip">
    //     <span class="material-icons md-sm md-dark">phone_forwarded</span>
    //     <span class="mc-tooltiptext mc-tooltiptext-right">${element.started_at_pretty}</span>
    //   </span>
    // </td>
    // <td style="font-size:80%;" scope="col" class="p-1 align-middle">
    //   <span class="p-0 mc-tooltip">
    //     <span class="material-icons md-sm md-dark">call_end</span>
    //     <span class="mc-tooltiptext mc-tooltiptext-right">${element.ended_at_pretty}</span>
    //   </span>
    // </td>`

    var rowHtml = `${tableRow}
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.started_at_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.started_at_time_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.ended_at_time_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.caller_name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.person_name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.phone_number}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${duration}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(element.call_price)}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.hangup_cause_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${playBtn}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${refreshBtn}</td>
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="row">
                        <div class="col-3 d-flex">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span data-app--helpers--search-target="footerTable"></span>
                          </div>
                        </div>
                        <div class="col-9 px-0">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                            <div class="dropdown">
                              <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${this.controllerNumber.numberMask(pagination.itemsOnPage)}</button>
                              <div class="dropdown-menu dropdown-menu-right menu">
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="300">300</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="750">750</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="1000">1.000</span>
                              </div>
                            </div>
                            <span class="align-self-center mb-1 mr-2 text-muted">${this.controllerNumber.numberMask(pagination.fromItem)}-${this.controllerNumber.numberMask(pagination.toItem)} de ${this.controllerNumber.numberMask(pagination.totalItems)}</span>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                          </div>
                        </div>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  listenToAudio(ev) {
    var callId = ev.currentTarget.closest(`.itemRow`).dataset.id
    var currentCall = {}

    this.current_calls.forEach(element => {
      if (element.id == callId) {
        currentCall = element
      }
    })

    this.current_audio = { service_url: currentCall.audio_url, content_type: currentCall.audio_content_type }

    this.getControllerByIdentifier(`app--helpers--pre-audio-modal`).current_audio = this.current_audio
    this.getControllerByIdentifier(`app--helpers--pre-audio-modal`).openModal({ message: `Escutar Áudio` })
  }

  showClearBtn() {
    this.clearListBtnTarget.classList.remove(`d-none`)
    this.optionBtnTarget.classList.add(`d-none`)
  }

  clearList() {
    this.clearListBtnTarget.classList.add(`d-none`)
    this.optionBtnTarget.classList.remove(`d-none`)

    this.getControllerByIdentifier("app--communications--interactions--entities--dashboard").doCallsDashboard()
  }

  playRecord(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_blank`)
  }

  goToFile(ev) {
    this.getControllerByIdentifier(`app--helpers--read-file`).feature_name = this.permission
    this.getControllerByIdentifier(`app--helpers--read-file`).goToFile(ev)
  }

  refreshSingleCall(ev) {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()
    var callId = ev.currentTarget.closest(`.itemRow`).dataset.id

    var data = { call: { active: true, id: callId }, current_user: { current_user_id: this.application.current_user.id, feature: this.permission } }
    const url = "/app/communications/voip/calls/refresh_single_call"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          var call = response.data.cln

          controller.application.calls.forEach((element, i) => {
            if (element.id == call.id) {
              controller.application.calls.splice(controller.application.calls.indexOf(element), 1, call)
            }
          })
        }

        controller.doDataTable()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  refreshCalls() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()

    if (this.dataMode == `record`) {
      var data = { call: { record_id: this.recordId, record_type: this.recordType }, current_user: { current_user_id: this.application.current_user.id, feature: this.permission } }
      var url = "/app/communications/voip/calls/list_by_record"
    } else if (this.dataMode == `obj`) {
      var data = { call: { obj_id: this.objId, obj_type: this.objType }, current_user: { current_user_id: this.application.current_user.id, feature: this.permission } }
      var url = "/app/communications/voip/calls/list_by_obj"
    }

    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.application.calls = response.data.cln

        controller.doDataTable()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    })
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    this.getControllerByIdentifier("app--helpers--console").console(results)
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
